export const LocaleTypes = ["ko", "en"] as const;
export type LocaleType = typeof LocaleTypes[number];
export const LocaleIntlKeys = {
    ko: "b0000_ko",
    en: "b0000_en"
} as const;
